<form [formGroup]="model" (ngSubmit)="aplicarFiltros()">
  <div class="row search-area">
    <div class="col-12 col-lg-4 search-field">
      <mat-form-field appearance="outline">
        <mat-label>Pesquisar</mat-label>
        <input matInput type="text" formControlName="pesquisa" placeholder="Pesquise pelo número do lote" />
        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-8 filter-container">
      <div class="local-field">
        <mat-form-field appearance="outline">
          <mat-label>Localização</mat-label>
          <mat-select formControlName="idLocalizacaoEstoque" (selectionChange)="aplicarFiltros()">
            <mat-option [value]="null">Todos</mat-option>
            @for (l of listaLocalizacaoEstoque; track l.idLocalizacaoEstoque) {
              <mat-option [value]="l.idLocalizacaoEstoque">{{ l.nome }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <button
        #periodoMenuTrigger="matMenuTrigger"
        mat-stroked-button
        type="button"
        class="btn-periodo"
        [matMenuTriggerFor]="periodoMenu"
        (menuOpened)="prepararPeriodoIntervalo()"
        [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoEnum.SemFiltro">
        {{ periodoLabel }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
        <div class="periodo-menu-content">
          <div>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.SemFiltro); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.SemFiltro">
              <span>sem filtro</span>
              @if (periodoSelecionado === PeriodoEnum.SemFiltro) {
                <mat-icon>check</mat-icon>
              }
            </button>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.Ultimos30Dias); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.Ultimos30Dias">
              <span>últimos 30 dias</span>
              @if (periodoSelecionado === PeriodoEnum.Ultimos30Dias) {
                <mat-icon>check</mat-icon>
              }
            </button>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.DoMes); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoMes">
              <span>do mês</span>
              @if (periodoSelecionado === PeriodoEnum.DoMes) {
                <mat-icon>check</mat-icon>
              }
            </button>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.DoIntervalo); $event.stopPropagation()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoIntervalo">
              <span>do intervalo</span>
              @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
                <mat-icon>check</mat-icon>
              }
            </button>

            @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
              <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline">
                  <mat-label>De</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerPeriodoDe"
                    [(ngModel)]="periodoIntervaloDe"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onPeriodoIntervaloChange('de', $event)"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDateBlur($event, 'de')"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [max]="periodoIntervaloAte" />
                  <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPeriodoDe></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Até</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerPeriodoAte"
                    [(ngModel)]="periodoIntervaloAte"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onPeriodoIntervaloChange('ate', $event)"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDateBlur($event, 'ate')"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [min]="periodoIntervaloDe" />
                  <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPeriodoAte></mat-datepicker>
                </mat-form-field>

                <div class="periodo-intervalo-actions">
                  <button
                    type="button"
                    mat-button
                    class="btn-secondary"
                    (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                    Cancelar
                  </button>
                  <button
                    type="button"
                    mat-flat-button
                    class="btn-primary"
                    (click)="aplicarPeriodo(periodoMenuTrigger)">
                    Aplicar
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </mat-menu>

      <button
        #filtrosAvancadosMenuTrigger="matMenuTrigger"
        mat-stroked-button
        type="button"
        class="btn-filter"
        [matMenuTriggerFor]="filtroMenu"
        [matBadge]="qtdFiltrosAvancados"
        [matBadgeHidden]="qtdFiltrosAvancados === 0">
        <mat-icon>filter_list</mat-icon>
        Filtrar
      </button>

      <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
        <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
          <h6>Filtros Avançados</h6>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Status</mat-label>
            <mat-select formControlName="idStatusFiltro">
              <mat-option [value]="_statusFiltroEnum.SemFiltro">Sem filtro</mat-option>
              <mat-option [value]="_statusFiltroEnum.Reservado">Reservado</mat-option>
              <mat-option [value]="_statusFiltroEnum.Disponivel">Disponível</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="filter-menu__actions">
            <button type="button" mat-button class="btn-secondary" matMenuClose (click)="filtrosAvancadosMenuTrigger.closeMenu()">Cancelar</button>
            <button type="button" mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
          </div>
        </div>
      </mat-menu>

      <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
        <mat-icon>cleaning_services</mat-icon>
        Limpar Filtros
      </button>
    </div>
  </div>
</form>

@if (_isLoading && _dataSource.data.length === 0) {
  <app-loading-box-default-list></app-loading-box-default-list>
} @else if (_dataSource.data.length === 0) {
  <app-empty-list [title]="'Nenhum lote encontrado'" [subTitle]="'Ajuste os filtros para refinar a busca'"></app-empty-list>
} @else {
  <div class="table-container desktop-view">
  <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
    <ng-container matColumnDef="dataValidade">
      <th mat-header-cell *matHeaderCellDef class="w-data-validade" mat-sort-header="dataValidade">Data validade</th>
      <td mat-cell *matCellDef="let row" class="w-data-validade">{{ row.dataValidade | date: 'dd/MM/yyyy' }}</td>
    </ng-container>

    <ng-container matColumnDef="numeroLote">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="numeroLote">Número do lote</th>
      <td mat-cell *matCellDef="let row">{{ row.numeroLote }}</td>
    </ng-container>

    <ng-container matColumnDef="localizacao">
      <th mat-header-cell *matHeaderCellDef>Local</th>
      <td mat-cell *matCellDef="let row">{{ row.localizacao || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="reservado">
      <th mat-header-cell *matHeaderCellDef class="text-end w-reservado" mat-sort-header="reservado">Reservado</th>
      <td mat-cell *matCellDef="let row" class="text-end w-reservado">{{ row.saldoReservado | abnt:'quantidade' }}</td>
    </ng-container>

    <ng-container matColumnDef="disponivel">
      <th mat-header-cell *matHeaderCellDef class="text-end w-disponivel" mat-sort-header="disponivel">Disponível</th>
      <td mat-cell *matCellDef="let row" class="text-end w-disponivel">
        <span class="disponivel-cell">
          {{ row.saldoDisponivel | abnt:'quantidade' }}
          <span class="dot" [ngClass]="classeBadge(row.statusBadge)" [matTooltip]="getHintStatus(row.statusBadge)"></span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="text-end w-actions">Ações</th>
      <td mat-cell *matCellDef="let row" class="text-end w-actions">
        <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações">
          <span class="material-symbols-outlined">more_horiz</span>
        </button>
        <mat-menu #menuRow="matMenu">
          <button mat-menu-item (click)="alterarDatas(row)">
            <mat-icon>event</mat-icon>
            <span>Alterar data de fabricação/validade</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  </div>

  <div class="mobile-view">
    @for (row of _dataSource.data; track $index) {
      <div class="card-mobile mb-3">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <span class="text-bold">Lote {{ row.numeroLote }}</span>
            <small>Validade: {{ row.dataValidade | date: 'dd/MM/yyyy' }}</small>
            <small>Local: {{ row.localizacao || '-' }}</small>
          </div>

          <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>

          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item (click)="alterarDatas(row)">
              <mat-icon>event</mat-icon>
              <span>Alterar data de fabricação/validade</span>
            </button>
          </mat-menu>
        </div>

        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Reservado</small>
              <span>{{ row.saldoReservado | abnt:'quantidade' }}</span>
            </div>

            <div class="col-6 mb-2">
              <small class="d-block">Disponível</small>
              <span class="disponivel-cell-mobile">
                {{ row.saldoDisponivel | abnt:'quantidade' }}
                <span class="dot" [ngClass]="classeBadge(row.statusBadge)" [matTooltip]="getHintStatus(row.statusBadge)"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="col-12 text-center">
    <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
      @if (_isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
      }
    </button>
  </div>
}
